import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";

export function FirmToggle({ style }) {
  const [on, setOn] = useState(null);
  useEffect(() => { api.get("/v2/today/firm").then(({ data }) => setOn(data.firm_checkin)).catch(() => setOn(false)); }, []);
  if (style !== "direct" || on === null) return null;
  const set = async (v) => {
    setOn(v);
    try { await api.put("/v2/today/firm", { on: v }); toast(v ? "6pm check-in is on." : "6pm check-in is off."); } catch (e) { setOn(!v); toast.error(errMsg(e)); }
  };
  return (
    <label className="flex items-center justify-between gap-3 mt-4 text-sm rounded-2xl bg-[#F5F2EC] p-3" data-testid="firm-checkin-row">
      <span><span className="font-medium block">6pm check-in</span><span className="text-xs text-stone-500">One push at 6pm if fewer than half of today's must-dos are done</span></span>
      <Switch checked={on} onCheckedChange={set} className="tap" data-testid="firm-checkin-switch" />
    </label>
  );
}
